var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    { staticClass: "circular-chart", attrs: { viewBox: "0 0 36 36" } },
    [
      _c("path", {
        staticClass: "circle-bg",
        class: _vm.circleClass,
        attrs: {
          d:
            "M18 2.0845\n    a 15.9155 15.9155 0 0 1 0 31.831\n    a 15.9155 15.9155 0 0 1 0 -31.831",
          "stroke-dasharray": "100, 100"
        }
      }),
      _c("path", {
        staticClass: "circle",
        style: _vm.cssVars,
        attrs: {
          d:
            "M18 2.0845\n    a 15.9155 15.9155 0 0 1 0 31.831\n    a 15.9155 15.9155 0 0 1 0 -31.831",
          "stroke-dasharray": `${_vm.percentage}, 100`
        }
      }),
      !_vm.hasIcon
        ? _c(
            "text",
            { staticClass: "percentage", attrs: { x: "18", y: "22.35" } },
            [_vm._v(" " + _vm._s(_vm.innerText || _vm.percentage) + " ")]
          )
        : _vm._e(),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }